import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faPrint, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFFactAportesMunicipales from './PDFFactAportesMunicipales';
class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        factAportes: [],
        datosAportesMunicipales: [],
        filename: ''
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar la Factura?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                let id_usuario = localStorage.getItem('idusuario');
                authAxios.get(`fact_aportes/borrar/${id}/${id_usuario}`)
                    .then((datosRespuesta) => {
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarFactAportes(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    ListarFactAportes(page) {
        Swal.showLoading();
        let bestado = document.getElementById('bestado').value;
        let bperiodo = document.getElementById('bperiodo').value;
        let bname = document.getElementById('bnombre').value;
        if (bestado == '') {
            bestado = 0;
        }
        if (bperiodo == '') {
            bperiodo = 0;
        }
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("fact_aportes/index/" + bestado + "/" + bperiodo + "/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', factAportes: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    previewPDFFactAportesMunicipales = (id_fact) => {
        authAxios.get(`fact_aportes/generar_factura/${id_fact}`)
            .then((response) => {
                var status = response.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }         
                const filename = `AGM - Factura Cliente Municipal ${response.data.resultAll.itemResultAporte.MUNICIPIO} - ${response.data.resultAll.itemResultAporte.PERIODO_FACTURA}.pdf`
                this.setState({ datosAportesMunicipales: response.data.resultAll, filename: filename });
            })
            .catch((error) => console.log(error))
    }
    componentDidMount() {
        this.ListarFactAportes(1);
    }
    render() {
        const { load, factAportes, pagina, ultimo, actual, datosAportesMunicipales, filename } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddFactAportesMunicipales"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Factura</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Facturas Aportes Municipales</h4>
                            <hr />
                            <div className="row">
                                <div className='col-md-12'>
                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="headingOne">
                                                <button style={{ fontSize: 14 }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <b>FILTROS</b>
                                                </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne">
                                                <div className="accordion-body">
                                                    <div className='row'>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bestado">Estado Factura</label>
                                                            <select name="bestado" id="bestado"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                <option value="">-</option>
                                                                <option value="1">ENTREGADO</option>
                                                                <option value="2">PENDIENTE DE ENVÍO</option>
                                                                <option value="3">RECLAMADA</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bperiodo">Periodo</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" id="bperiodo" name="bperiodo" placeholder="PERIODO" min="0" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="bnombre">Municipio</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="MUNICIPIO" className="form-control form-control-sm" />
                                                        </div>
                                                        <div style={{ marginTop: 32 }} className="col-xl-1">
                                                            <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarFactAportes(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className='col-xl-12'>
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                <th className="align-middle">CUENTA COBRO</th>
                                                <th className="align-middle">VALOR FACTURA</th>
                                                <th className="align-middle">PERIODO</th>
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                factAportes.map((itemFactAportes) => (
                                                    <tr key={itemFactAportes.ID_FACTURACION}>
                                                        {
                                                            (() => {
                                                                switch (itemFactAportes.ESTADO_FACTURA) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">E</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#ADAEAF' }} className="badge">PE</span></td>)
                                                                    case 3:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#4D7B52' }} className="badge">R</span></td>)

                                                                }
                                                            })()
                                                        }
                                                        <td>{itemFactAportes.DEPARTAMENTO}</td>
                                                        <td>{itemFactAportes.MUNICIPIO}</td>
                                                        <td>{itemFactAportes.CONSECUTIVO_FACT}</td>
                                                        <td><b>$ </b>{currencyFormat(itemFactAportes.VALOR_FACTURA)}</td>
                                                        <td>{itemFactAportes.PERIODO_FACTURA}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpFactAportesMunicipales/" + itemFactAportes.ID_FACTURACION}
                                                                >
                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemFactAportes.ID_FACTURACION)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm"
                                                                    data-bs-toggle='modal'
                                                                    data-bs-target="#PDFFactAportesMunicipalesModal"
                                                                    slot='end'
                                                                    onClick={() => {
                                                                        this.previewPDFFactAportesMunicipales(itemFactAportes.ID_FACTURACION)
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faPrint} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">E</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>ENTREGADO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#ADAEAF' }} className="badge">PE</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PENDIENTE ENVÍO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#4D7B52' }} className="badge">R</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>RECLAMADA</b></span>&nbsp;
                            <nav style={{ marginTop: 15 }} aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactAportes(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactAportes(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarAporte(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactAportes(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactAportes(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="PDFFactAportesMunicipalesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ActaInterventoriaoLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Facturación Aportes Municipales</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFFactAportesMunicipales data={datosAportesMunicipales} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Descargar PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>

                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFFactAportesMunicipales data={datosAportesMunicipales} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;